// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zebstrika: PokeData = {
  "id": 523,
  "name": "zebstrika",
  "height": 16,
  "weight": 795,
  "base_experience": 174,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "stomp",
    "thrash",
    "tail-whip",
    "thunder-wave",
    "agility",
    "quick-attack",
    "spark",
    "pursuit",
    "charge",
    "shock-wave",
    "discharge",
    "flame-charge",
    "wild-charge",
    "ion-deluge"
  ],
  "moves": [
    "quick-attack",
    "pursuit",
    "wild-charge",
    "thunder",
    "electric-terrain",
    "volt-crash",
    "quick-tempo",
    "electric-wrath",
    "volt-switch",
    "zap-cannon",
    "thunderbolt",
    "thunder-fang",
    "thunder-punch"
  ],
  "evolution_chain": {
    "id": 267,
    "item": null,
    "species": [
      {
        "name": "blitzle",
        "order": 523,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "zebstrika",
        "order": 524,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 522,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 27,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 97,
    "speed": 163,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
